import type { ComponentType } from "react";

import Home from "../pages/Home";
import Pricing from "../pages/Pricing";
import BrowseAds from "../pages/BrowseAds";
import AdDetail from "../pages/AdDetail";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import SafetyGuidelines from "../pages/SafetyGuidelines";
import About from "../pages/About";
import HelpCenter from "../pages/HelpCenter";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";
import Contact from "../pages/Contact";
import Careers from "../pages/Careers";
import Press from "../pages/Press";
import Blog from "../pages/Blog";
import MobileApps from "../pages/MobileApps";
import PostAd from "../pages/PostAd";
import Dashboard from "../pages/Dashboard";
import SurveyMissions from "../pages/SurveyMissions";
import Messages from "../pages/Messages";
import Profile from "../pages/Profile";
import UserProfile from "../pages/UserProfile";
import AdminDashboard from "../pages/AdminDashboard";
import Staking from "../pages/Staking";
import ComponentShowcase from "../pages/ComponentShowcase";
import CityLanding from "../pages/CityLanding";
import EmailPreview from "../pages/EmailPreview";
import NotFound from "../pages/NotFound";

export type RouteDefinition = {
  path: string;
  component: ComponentType<any>;
  requiresAuth?: boolean;
  navKey?: string;
  includeInPrimaryNav?: boolean;
  visibility?: "all" | "signedIn" | "signedOut";
};

export const ROUTES: RouteDefinition[] = [
  { path: "/", component: Home },
  { path: "/pricing", component: Pricing },
  { path: "/browse", component: BrowseAds, navKey: "nav.browse", includeInPrimaryNav: true },
  { path: "/ads/:id", component: AdDetail },
  { path: "/sign-in", component: SignIn, visibility: "signedOut" },
  { path: "/sign-up", component: SignUp, visibility: "signedOut" },
  { path: "/safety-guidelines", component: SafetyGuidelines },
  { path: "/about", component: About },
  { path: "/help", component: HelpCenter },
  { path: "/terms", component: Terms },
  { path: "/privacy", component: Privacy },
  { path: "/contact", component: Contact },
  { path: "/careers", component: Careers },
  { path: "/press", component: Press },
  { path: "/blog", component: Blog },
  { path: "/apps", component: MobileApps },
  { path: "/post", component: PostAd, requiresAuth: true },
  { path: "/dashboard", component: Dashboard, requiresAuth: true, navKey: "nav.dashboard", includeInPrimaryNav: true, visibility: "signedIn" },
  { path: "/surveys", component: SurveyMissions, requiresAuth: true, navKey: "nav.surveys", includeInPrimaryNav: true, visibility: "signedIn" },
  { path: "/messages", component: Messages, requiresAuth: true, navKey: "nav.messages" },
  { path: "/profile", component: Profile, requiresAuth: true },
  { path: "/users/:id", component: UserProfile },
  { path: "/admin", component: AdminDashboard, requiresAuth: true },
  { path: "/staking", component: Staking },
  { path: "/staking", component: Staking },
  { path: "/showcase", component: ComponentShowcase },
  { path: "/personals/:country/:city", component: CityLanding },
  { path: "/emails", component: EmailPreview },
  { path: "/404", component: NotFound },
];

export const publicRoutes = ROUTES.filter((route) => !route.requiresAuth);
export const protectedRoutes = ROUTES.filter((route) => route.requiresAuth);

export type PrimaryNavLink = {
  href: string;
  translationKey: string;
  visibility: "all" | "signedIn" | "signedOut";
};

export const primaryNavLinks: PrimaryNavLink[] = ROUTES
  .filter((route) => route.includeInPrimaryNav && route.navKey)
  .map((route) => ({
    href: route.path,
    translationKey: route.navKey as string,
    visibility: route.visibility ?? (route.requiresAuth ? "signedIn" : "all"),
  }));
